/**
 * @prettier
 */
import { BigNumber } from 'bignumber.js';
import { locale } from 'src/config/configureI18n';
import { Currencies, Currency } from 'src/constants/Currency';

export function formatAsNumberCurrency(value?: string | number | null, currency?: Currency, customFractionDigits?: number): string {
    if (value === undefined || value === null) {
        return '';
    }
    if (!currency) {
        currency = Currencies.MXN;
    }

    const fractionDigits = customFractionDigits ?? (BigNumber(value).toString().includes('.') ? 2 : 0);
    let numberWithFormat = Intl.NumberFormat(locale ?? 'es-MX', {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(Number(value));

    numberWithFormat = numberWithFormat.replace(/\b[A-Z]{3}\b/g, '$');

    if (!fractionDigits && numberWithFormat.includes('.')) {
        const [ints, fracs] = numberWithFormat.split('.');
        const cleanFracs = fracs.split('').reverse().join('').replace(/^(0+)/g, '').split('').reverse().join('');

        return `${ints}.${cleanFracs}`;
    }

    return numberWithFormat;
}
